import { Link } from "react-router-dom";
import { categories } from "@/mocks/home";

export default function CategoryCards() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            精选品类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            四大核心品类，汇集亚洲各国最具代表性的品质好物
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300 no-underline cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${cat.icon} text-base`} />
                  </div>
                  <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-3 flex items-center gap-1 text-primary-600 text-xs font-medium">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line text-xs" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}